@if (comoUser) {
  @if (displayAssets) {
    <div
      class="md:container md:mx-auto lg:mx-auto lg:max-w-screen-sm kiosk:mx-0 kiosk:max-w-full rounded-md bg-neutral-100"
    >
      <app-como-asset-list-atom
        [assets]="comoUser.assets"
        [heading]="assetsHeading | translate"
        [subheading]="assetsSubheading"
        [creditBalance]="comoUser.credit_balance.monetary"
        [pointsBalance]="comoUser.points_balance.non_monetary"
        [displayCredits]="displayCredits"
        [displayPoints]="displayPoints"
        [displayAddButton]="true"
        (onAssetAdd)="onAssetAdd($event)"
        (onAssetRemove)="onAssetRemove($event)"
      ></app-como-asset-list-atom>
    </div>
  }
}
